/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */
exports.isValid = function isValid (version) {
  return !isNaN(version) && version >= 1 && version <= 40
}



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/qrcode@1.5.4/~/qrcode/lib/core/version-check.js
// module id = 295
// module chunks = 0